// in src/NotFound.js
import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const Error403 = () => (
    <Card>
        <CardContent>
            <h1>403: Forbidden</h1>
        </CardContent>
    </Card>
);

export default Error403;